import { useForm } from 'react-hook-form'
import { FormObjectType, SearchFormItemsType } from 'src/types/react-hook-form'

const useSearchForm = () => {
  const methods = useForm<SearchFormItemsType>({
    mode: 'onBlur',
    defaultValues: {
      word: '',
    },
  })
  const { setValue } = methods

  const searchWordOnchange = (event: { target: { value: string } }) => {
    setValue('word', event.target.value, { shouldValidate: true })
  }

  const registerAttribute: Record<keyof SearchFormItemsType, Partial<FormObjectType>> = {
    word: {
      placeholder: '검색어 입력',
      tag: 'word',
      register_options: {
        minLength: 1,
        required: true,
        onChange: searchWordOnchange,
      },
    },
  }

  return {
    methods,
    registerAttribute,
  }
}
export default useSearchForm
